<template>
  <div class="max-w-screen-xl mx-auto mt-16 md:mt-20 lg:mt-32 xl:mt-40">
    <h2 class="lg:text-center max-w-6xl  text-3xl md:text-4xl lg:text-5xl font-semibold">
      {{ dataLocale.any_content.title }}
    </h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 mt-12 lg:mt-20 lg:grid-cols-3 gap-x-8 sm:gap-x-12 gap-y-12 lg:gap-y-22">
      <div class="grid lg:justify-items-center sm:p-0 p-4 sm:border-none border-2 border-success-light rounded-lg" v-for="reason in dataLocale.data">
        <div class="bg-success-light flex items-center justify-center w-20 h-20 place-content-center rounded-2xl">
          <component v-bind:is="reason.icon" class="w-16 h-16 text-success" />
        </div>
        <h6 class="mt-4 mb-4 lg:text-center  text-xl md:text-2xl font-semibold" :class="{ 'font-inter': locale == 'vi' }">
          {{ reason.title }}
        </h6>
        <p class="max-w-sm lg:text-lg sm:max-w-md lg:text-center text-neutrals-light-10">
          {{ reason.description }}
        </p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import BagIcon from "~/assets/svg/marketing/bag.svg?component";
import BrandingIcon from "~/assets/svg/marketing/branding.svg?component";
import CardIcon from "~/assets/svg/marketing/card.svg?component";
import ConnectIcon from "~/assets/svg/marketing/connect.svg?component";
import ConversionIcon from "~/assets/svg/marketing/conversion.svg?component";
import PrintIcon from "~/assets/svg/marketing/print.svg?component";
import TrendingIcon from "~/assets/svg/marketing/trending.svg?component";
import MultiDataLocale from "~~/config/interface/MultiDataLocale";
export default defineComponent({
  components: {
    BagIcon,
    BrandingIcon,
    CardIcon,
    ConnectIcon,
    ConversionIcon,
    PrintIcon,
    TrendingIcon,
  },
  setup() {
    const dataLocale = new MultiDataLocale([
      {
        locale: "en",
        title: "Why QR Code Marketing is a Smart Choice",
        data: [
          {
            icon: "TrendingIcon",
            title: "Stay on Trend with Mobile Marketing",
            description:
              "Mobile marketing is a hot trend, and using it to provide customers with fun and convenient ways to access information, discounts, and promotions can keep you ahead of the competition.",
          },
          {
            icon: "BagIcon",
            title: "Track Customer Behavior to Improve Your Marketing",
            description:
              "By using tracking tools like QR codes, you can gain insights into your customers' preferences and interests, helping you better tailor your marketing efforts to their needs.",
          },
          {
            icon: "PrintIcon",
            title: "Expand Your Reach with Print Publications",
            description:
              "Add QR codes to your print materials, like flyers, brochures, and business cards, to make it easy for customers to access your information and promotions offline.",
          },
          {
            icon: "CardIcon",
            title: "Save Time and Money with Easy-to-Use Marketing Tools",
            description:
              "QR codes are a cost-effective marketing tool that can be easily created and printed, saving you time and money on your marketing campaigns.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Boost Marketing Effectiveness with Seamless Customer Experiences",
            description:
              "QR codes provide customers with a seamless experience, making it easier to attract and retain them. By offering easy access to information and promotions, you can improve the effectiveness of your marketing efforts.",
          },
          {
            icon: "BrandingIcon",
            title: "Enhance Brand Awareness with Customizable QR Codes",
            description:
              "QR codes can be customized with your brand logo and colors, helping you increase brand awareness and recognition among your target audience.",
          },
        ]
      },
      {
        locale: "vi",
        title: " Tại sao tiếp thị QR Code là sự lựa chọn thông minh",
        data: [
          {
            icon: "TrendingIcon",
            title: "Luôn cập nhật xu hướng với tiếp thị di động",
            description:
              "Tiếp thị di động là một xu hướng phổ biến, và sử dụng nó để cung cấp cho khách hàng các cách tiếp cận thông tin, giảm giá và khuyến mãi vui vẻ và thuận tiện có thể giúp bạn luôn đứng trước đối thủ cạnh tranh.",
          },
          {
            icon: "BagIcon",
            title: "Theo dõi hành vi khách hàng để cải thiện chiến lược tiếp thị",
            description:
              "Bằng cách sử dụng các công cụ theo dõi như QR code, bạn có thể nắm bắt được sở thích và quan tâm của khách hàng, giúp bạn điều chỉnh chiến lược tiếp thị của mình để phù hợp hơn với nhu cầu của họ.",
          },
          {
            icon: "PrintIcon",
            title: "Mở rộng tầm với với các ấn phẩm in",
            description:
              "Thêm QR code vào các tài liệu in của bạn, như tờ rơi, brochure và danh thiếp, để dễ dàng cho khách hàng truy cập thông tin và khuyến mãi của bạn offline.",
          },
          {
            icon: "CardIcon",
            title: "Tiết kiệm thời gian và tiền bạc với các công cụ tiếp thị dễ sử dụng",
            description:
              "QR code là một công cụ tiếp thị tiết kiệm chi phí có thể được tạo và in dễ dàng, giúp bạn tiết kiệm thời gian và tiền bạc cho các chiến dịch tiếp thị của mình.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Tăng độ hiệu quả tiếp thị với trải nghiệm khách hàng liền mạch",
            description:
              "QR code cung cấp cho khách hàng một trải nghiệm mượt mà, giúp bạn dễ dàng thu hút và giữ chân họ. Bằng cách cung cấp khả năng truy cập thông tin và khuyến mãi dễ dàng, bạn có thể nâng cao hiệu quả của chiến dịch tiếp thị của mình.",
          }, {
            icon: "BrandingIcon",
            title: "Tăng cường nhận thức về thương hiệu với mã QR có thể tùy chỉnh",
            description:
              "Mã QR có thể được tùy chỉnh với logo và màu sắc của thương hiệu của bạn, giúp bạn tăng cường nhận thức và nhận diện thương hiệu trong đối tượng khách hàng mục tiêu.",
          }
        ]
      },
      {
        locale: "de",
        title:"Warum QR-Code-Marketing eine kluge Wahl ist",
        data: [
          {
            icon: "TrendingIcon",
            title: "Bleiben Sie mit Mobile Marketing im Trend",
            description:
              "Mobile Marketing ist ein heißer Trend, und indem Sie Kunden lustige und bequeme Möglichkeiten bieten, auf Informationen, Rabatte und Aktionen zuzugreifen, können Sie sich gegenüber der Konkurrenz behaupten.",
          },
          {
            icon: "BagIcon",
            title: "Verfolgen Sie das Kundenverhalten, um Ihr Marketing zu verbessern",
            description:
              "Durch die Verwendung von Tracking-Tools wie QR-Codes können Sie Einblicke in die Vorlieben und Interessen Ihrer Kunden gewinnen und Ihre Marketingbemühungen besser auf ihre Bedürfnisse abstimmen.",
          },
          {
            icon: "PrintIcon",
            title: "Erweitern Sie Ihre Reichweite mit gedruckten Publikationen",
            description:
              "Fügen Sie QR-Codes zu Ihren gedruckten Materialien wie Flyern, Broschüren und Visitenkarten hinzu, um es Kunden einfach zu machen, offline auf Ihre Informationen und Aktionen zuzugreifen.",
          },
          {
            icon: "CardIcon",
            title: "Sparen Sie Zeit und Geld mit einfach zu verwendenden Marketing-Tools",
            description:
              "QR-Codes sind ein kosteneffektives Marketing-Tool, das leicht erstellt und gedruckt werden kann und Ihnen Zeit und Geld bei Ihren Marketingkampagnen spart.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Steigern Sie die Marketingeffektivität mit nahtlosen Kundenerlebnissen",
            description:
              "QR-Codes bieten Kunden ein nahtloses Erlebnis, was es einfacher macht, sie zu gewinnen und zu halten. Durch einfache Zugänge zu Informationen und Aktionen können Sie die Effektivität Ihrer Marketingbemühungen verbessern.",
          },
          {
            icon: "BrandingIcon",
            title: "Erhöhen Sie die Markenbekanntheit mit anpassbaren QR-Codes",
            description:
              "QR-Codes können mit Ihrem Markenlogo und -farben angepasst werden, um die Markenbekanntheit und -wiedererkennung bei Ihrer Zielgruppe zu steigern.",
          },
        ]
      },
      {
        locale: "fr",
        title: "Pourquoi le marketing par code QR est un choix intelligent",
        data: [
          {
            icon: "TrendingIcon",
            title: "Rester dans la tendance avec le marketing mobile",
            description:
              "Le marketing mobile est une tendance très prisée et en utilisant celui-ci pour offrir aux clients des moyens amusants et pratiques d'accéder aux informations, aux remises et aux promotions, vous pouvez rester en avance sur la concurrence.",
          },
          {
            icon: "BagIcon",
            title: "Suivre le comportement des clients pour améliorer votre marketing",
            description:
              "En utilisant des outils de suivi tels que les codes QR, vous pouvez obtenir des informations sur les préférences et les intérêts de vos clients, ce qui vous permet de mieux adapter vos efforts de marketing à leurs besoins.",
          },
          {
            icon: "PrintIcon",
            title: "Élargir votre portée avec des publications imprimées",
            description:
              "Ajoutez des codes QR à vos supports imprimés, tels que des flyers, des brochures et des cartes de visite, pour permettre aux clients d'accéder facilement à vos informations et promotions hors ligne.",
          },
          {
            icon: "CardIcon",
            title: "Économisez du temps et de l'argent avec des outils de marketing faciles à utiliser",
            description:
              "Les codes QR sont un outil de marketing rentable qui peut être facilement créé et imprimé, vous faisant ainsi gagner du temps et de l'argent sur vos campagnes de marketing.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Augmenter l'efficacité du marketing avec des expériences client fluides",
            description:
              "Les codes QR offrent aux clients une expérience fluide, ce qui facilite l'attirance et la fidélisation. En offrant un accès facile aux informations et promotions, vous pouvez améliorer l'efficacité de vos efforts de marketing.",
          },
          {
            icon: "BrandingIcon",
            title: "Renforcer la notoriété de la marque avec des codes QR personnalisables",
            description:
              "Les codes QR peuvent être personnalisés avec votre logo et vos couleurs de marque, vous aidant ainsi à accroître la notoriété et la reconnaissance de votre marque auprès de votre public cible.",
          },
        ]
      },
      {
        locale: "it",
        title:"Perché il marketing con codice QR è una scelta intelligente",
        data: [
          {
            icon: "TrendingIcon",
            title: "Restare al passo con il marketing mobile",
            description:
              "Il marketing mobile è una tendenza molto popolare e utilizzarlo per offrire ai clienti modi divertenti e convenienti per accedere alle informazioni, agli sconti e alle promozioni può mantenerlo in vantaggio sulla concorrenza.",
          },
          {
            icon: "BagIcon",
            title: "Monitorare il comportamento dei clienti per migliorare il tuo marketing",
            description:
              "Utilizzando strumenti di monitoraggio come i codici QR, è possibile ottenere informazioni sulle preferenze e gli interessi dei propri clienti, aiutando a personalizzare meglio gli sforzi di marketing alle loro esigenze.",
          },
          {
            icon: "PrintIcon",
            title: "Ampliare la portata con pubblicazioni cartacee",
            description:
              "Aggiungere codici QR ai propri materiali cartacei, come volantini, brochure e biglietti da visita, per rendere facile per i clienti l'accesso alle informazioni e alle promozioni offline.",
          },
          {
            icon: "CardIcon",
            title: "Risparmiare tempo e denaro con strumenti di marketing facili da usare",
            description:
              "I codici QR sono uno strumento di marketing conveniente che può essere facilmente creato e stampato, risparmiando tempo e denaro sulle campagne di marketing.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Aumentare l'efficacia del marketing con esperienze clienti fluide",
            description:
              "I codici QR offrono ai clienti un'esperienza fluida, rendendo più facile attrarre e mantenere la loro fedeltà. Offrendo un facile accesso alle informazioni e alle promozioni, è possibile migliorare l'efficacia degli sforzi di marketing.",
          },
          {
            icon: "BrandingIcon",
            title: "Migliorare la consapevolezza del marchio con codici QR personalizzabili",
            description:
              "I codici QR possono essere personalizzati con il proprio logo e i colori del marchio, aiutando a migliorare la consapevolezza e il riconoscimento del marchio tra il pubblico di destinazione.",
          },
        ]
      },
      {
        locale: "es",
        title:"Por qué el marketing con códigos QR es una elección inteligente",
        data: [
          {
            icon: "TrendingIcon",
            title: "Manténgase en tendencia con el marketing móvil",
            description:
              "El marketing móvil es una tendencia candente, y utilizarlo para brindar a los clientes formas divertidas y convenientes de acceder a información, descuentos y promociones puede mantenerlo por delante de la competencia.",
          },
          {
            icon: "BagIcon",
            title: "Realice un seguimiento del comportamiento del cliente para mejorar su marketing",
            description:
              "Al utilizar herramientas de seguimiento como códigos QR, puede obtener información sobre las preferencias e intereses de sus clientes, lo que le ayudará a adaptar mejor sus esfuerzos de marketing a sus necesidades.",
          },
          {
            icon: "PrintIcon",
            title: "Amplíe su alcance con publicaciones impresas",
            description:
              "Agregue códigos QR a sus materiales impresos, como volantes, folletos y tarjetas de presentación, para que sea fácil para los clientes acceder a su información y promociones fuera de línea.",
          },
          {
            icon: "CardIcon",
            title: "Ahorre tiempo y dinero con herramientas de marketing fáciles de usar",
            description:
              "Los códigos QR son una herramienta de marketing rentable que se puede crear e imprimir fácilmente, lo que le ahorrará tiempo y dinero en sus campañas de marketing.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Aumente la efectividad del marketing con experiencias de cliente fluidas",
            description:
              "Los códigos QR brindan a los clientes una experiencia fluida, lo que hace que sea más fácil atraerlos y retenerlos. Al ofrecer un fácil acceso a información y promociones, puede mejorar la efectividad de sus esfuerzos de marketing.",
          },
          {
            icon: "BrandingIcon",
            title: "Mejore la conciencia de marca con códigos QR personalizables",
            description:
              "Los códigos QR se pueden personalizar con su logotipo y colores de marca, lo que ayuda a aumentar la conciencia y el reconocimiento de su marca entre su público objetivo.",
          },
        ]
      },
      {
        locale: "nl",
        title: "Waarom QR-code marketing een slimme keuze is",
        data: [
          {
            icon: "TrendingIcon",
            title: "Blijf in de trend met mobiele marketing",
            description:
              "Mobiele marketing is een hot trend, en door het aanbieden van leuke en handige manieren voor klanten om informatie, kortingen en promoties te krijgen, kun je voorop blijven lopen op de concurrentie.",
          },
          {
            icon: "BagIcon",
            title: "Volg klantgedrag om je marketing te verbeteren",
            description:
              "Door tracking tools zoals QR-codes te gebruiken, kun je inzicht krijgen in de voorkeuren en interesses van je klanten, waardoor je je marketinginspanningen beter kunt afstemmen op hun behoeften.",
          },
          {
            icon: "PrintIcon",
            title: "Breid je bereik uit met gedrukte publicaties",
            description:
              "Voeg QR-codes toe aan je gedrukte materialen, zoals flyers, brochures en visitekaartjes, zodat klanten gemakkelijk toegang hebben tot je informatie en promoties offline.",
          },
          {
            icon: "CardIcon",
            title: "Bespaar tijd en geld met eenvoudig te gebruiken marketingtools",
            description:
              "QR-codes zijn een kosteneffectieve marketingtool die gemakkelijk kan worden gemaakt en afgedrukt, waardoor je tijd en geld bespaart op je marketingcampagnes.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Verbeter de effectiviteit van marketing met naadloze klantervaringen",
            description:
              "QR-codes bieden klanten een naadloze ervaring, waardoor het gemakkelijker wordt om ze aan te trekken en te behouden. Door gemakkelijke toegang te bieden tot informatie en promoties, kun je de effectiviteit van je marketinginspanningen verbeteren.",
          },
          {
            icon: "BrandingIcon",
            title: "Verbeter de merkbekendheid met aanpasbare QR-codes",
            description:
              "QR-codes kunnen worden aangepast met je merklogo en -kleuren, waardoor je de merkbekendheid en -herkenning bij je doelgroep kunt vergroten.",
          },
        ]
      },
      {
        locale: "pt",
        title: "Waarom QR-code marketing een slimme keuze is",
        data: [
          {
            icon: "TrendingIcon",
            title: "Mantenha-se na tendência com marketing móvel",
            description:
              "O marketing móvel é uma tendência quente e, ao oferecer maneiras divertidas e convenientes para os clientes acessarem informações, descontos e promoções, você pode se manter à frente da concorrência.",
          },
          {
            icon: "BagIcon",
            title: "Acompanhe o comportamento do cliente para melhorar seu marketing",
            description:
              "Usando ferramentas de rastreamento como códigos QR, você pode obter insights sobre as preferências e interesses de seus clientes, ajudando a adaptar melhor seus esforços de marketing às necessidades deles.",
          },
          {
            icon: "PrintIcon",
            title: "Amplie seu alcance com publicações impressas",
            description:
              "Adicione códigos QR aos seus materiais impressos, como panfletos, brochuras e cartões de visita, para tornar fácil para os clientes acessarem suas informações e promoções offline.",
          },
          {
            icon: "CardIcon",
            title: "Economize tempo e dinheiro com ferramentas de marketing fáceis de usar",
            description:
              "Os códigos QR são uma ferramenta de marketing econômica que pode ser facilmente criada e impressa, economizando tempo e dinheiro em suas campanhas de marketing.",
          },
          {
            icon: "ConversionIcon",
            title:
              "Aumente a eficácia do marketing com experiências perfeitas para o cliente",
            description:
              "Os códigos QR oferecem aos clientes uma experiência perfeita, tornando mais fácil atraí-los e retê-los. Oferecendo fácil acesso a informações e promoções, você pode melhorar a eficácia de seus esforços de marketing.",
          },
          {
            icon: "BrandingIcon",
            title: "Aumente a conscientização da marca com códigos QR personalizáveis",
            description:
              "Os códigos QR podem ser personalizados com o logotipo e as cores de sua marca, ajudando você a aumentar a conscientização e o reconhecimento da marca entre seu público-alvo.",
          },
        ]
      },
      {
        locale: "ja",
        title: "QRコードマーケティングがスマートな選択である理由",
        data: [
          {
            icon: "TrendingIcon",
            title: "モバイルマーケティングでトレンドに合わせよう",
            description:
              "モバイルマーケティングは今熱いトレンドです。情報、割引、プロモーションを提供することで、お客様に楽しく便利な方法を提供することで、競合他社よりも先行できます。",
          },
          {
            icon: "BagIcon",
            title: "お客様の行動をトラッキングしてマーケティングを改善しましょう",
            description:
              "QRコードなどのトラッキングツールを使用することで、お客様の好みや興味を把握し、そのニーズに合わせてマーケティング努力を改善することができます。",
          },
          {
            icon: "PrintIcon",
            title: "印刷物でリーチを広げよう",
            description:
              "フライヤーやパンフレット、名刺などの印刷物にQRコードを追加することで、お客様がオフラインでも情報やプロモーションにアクセスしやすくなります。",
          },
          {
            icon: "CardIcon",
            title: "使いやすいマーケティングツールで時間とお金を節約しよう",
            description:
              "QRコードはコスト効率の高いマーケティングツールで、簡単に作成して印刷することができます。そのため、マーケティングキャンペーンに時間とお金を節約することができます。",
          },
          {
            icon: "ConversionIcon",
            title:
              "シームレスなカスタマーエクスペリエンスでマーケティング効果を高めよう",
            description:
              "QRコードはお客様にシームレスなエクスペリエンスを提供するため、彼らを引きつけ、維持しやすくなります。情報やプロモーションへの簡単なアクセスを提供することで、マーケティング努力の効果を向上させることができます。",
          },
          {
            icon: "BrandingIcon",
            title: "カスタマイズ可能なQRコードでブランド認知度を向上しよう",
            description: "QRコードは、ブランドのロゴと色でカスタマイズできるため、ターゲットオーディエンスの間でブランドの認知度と認知度を高めるのに役立ちます."
          }
        ]
      },
      {
        locale: "zh",
        title:"为什么QR码营销是明智的选择",
        data: [
          {
            icon: "TrendingIcon",
            title: "移动营销时尚跟进",
            description:
              "移动营销是一个热门趋势，利用它为客户提供有趣和方便的方式来访问信息、折扣和促销活动，可以让您保持领先。",
          },
          {
            icon: "BagIcon",
            title: "跟踪客户行为以改进营销",
            description:
              "通过使用二维码等跟踪工具，您可以了解客户的偏好和兴趣，帮助您更好地根据他们的需求定制营销策略。",
          },
          {
            icon: "PrintIcon",
            title: "通过印刷出版物扩大您的影响力",
            description:
              "将二维码添加到您的印刷材料中，例如传单、宣传册和名片，以便客户能够轻松离线访问您的信息和促销活动。",
          },
          {
            icon: "CardIcon",
            title: "使用易于使用的营销工具节省时间和金钱",
            description:
              "二维码是一种经济实惠的营销工具，可以轻松创建和打印，从而节省您的营销活动所需的时间和金钱。",
          },
          {
            icon: "ConversionIcon",
            title: "通过无缝的客户体验提高营销效果",
            description:
              "二维码为客户提供了无缝的体验，使吸引和保留客户变得更加容易。通过提供简单的信息和促销活动访问方式，您可以提高营销效果。",
          },
          {
            icon: "BrandingIcon",
            title: "使用可定制的二维码增强品牌认知度",
            description:
              "二维码可以定制您的品牌标志和颜色，帮助您提高目标受众对品牌的认知和认可度。",
          },
        ]
      },
    ])
    const { locale } = useI18n()
    return {
      dataLocale, locale
    };
  },
});
</script>
